import React, { useState } from "react";

const OCRContext = React.createContext({
  activePage: 0,
  file: null,
  attachments: [],
  invoiceId: null,
  isInvoice: true,
  vendorCode: null,
  invoiceNumber: null,
  companyId: null,
  functionId: null,
  extractedData: null,
  rawVendorData: null,
  setActivePage: () => {},
  setFile: () => {},
  addAttachment: () => {},
  setInvoiceId: () => {},
  setIsInvoice: () => {},
  setVendorCode: () => {},
  setInvoiceNumber: () => {},
  setCompanyId: () => {},
  setFunctionId: () => {},
  setExtractedData: () => {},
  setRawVendorData: () => {},
  resetOCRState: () => {},
});

export const OCRContextProvider = (props) => {
  const [activePage, setActivePage] = useState(0);
  const [file, setFile] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [invoiceId, setInvoiceId] = useState(null);
  const [isInvoice, setIsInvoice] = useState(true);
  const [vendorCode, setVendorCode] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [functionId, setFunctionId] = useState(null);
  const [extractedData, setExtractedData] = useState(null);
  const [rawVendorData, setRawVendorData] = useState(null);

  const addAttachment = (file) => {
    const newAttachment = {
      file,
      fileName: file.name,
    };
    setAttachments((prev) => [...prev, newAttachment]);
  };

  const resetOCRState = () => {
    setActivePage(0);
    setFile(null);
    setAttachments([]);
    setInvoiceId(null);
    setIsInvoice(true);
    setVendorCode(null);
    setInvoiceNumber(null);
    setCompanyId(null);
    setFunctionId(null);
    setExtractedData(null);
    setRawVendorData(null);
  };

  const contextValue = {
    activePage,
    file,
    attachments,
    invoiceId,
    isInvoice,
    vendorCode,
    invoiceNumber,
    companyId,
    functionId,
    extractedData,
    rawVendorData,
    setActivePage,
    setFile,
    addAttachment,
    setInvoiceId,
    setIsInvoice,
    setVendorCode,
    setInvoiceNumber,
    setCompanyId,
    setFunctionId,
    setExtractedData,
    setRawVendorData,
    resetOCRState,
  };

  return <OCRContext.Provider value={contextValue}>{props.children}</OCRContext.Provider>;
};

export default OCRContext;